import React from 'react';
import Header from "../Components/Header.js";
import Contact from "../Components/Contact.js";
import Footer from "../Components/Footer.js";
import AllProjects from '../Components/AllProjects.js';

const Projects = () => {
    return (
        <div className="projects-container">
        <div className="page-content">  
        <Header />
        <AllProjects />
        </div>
        <div className="page-footer">
        <Contact />
        <Footer />
        </div>
        </div>
    );
  };

export default Projects;
